module.exports = __webpack_public_path__ + "static/img/10.fb02ca0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/10.jpg
// module id = qFU1
// module chunks = 1